<template>
  <div class="x-color-tag">
    <template v-if="tag">
      <div
        :style="{ 'background-color': widget.multicolor ? tag.color : '#fafafa', 'color': widget.multicolor ? '#FFFFFF' : '#303133' }"
        class="select-read-tag"
      >
        <span>{{tag.label}}</span>
      </div>
    </template>
    <template v-else>
      <div
        :style="{ 'background-color': widget.multicolor ? tag.color : '#fafafa', 'color': widget.multicolor ? '#FFFFFF' : '#303133' }"
        class="select-read-tag"
        v-for="tag in formValueShowList"
        :key="tag.id"
      >
        <span>{{tag.label}}</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'XColorTag',
  props: {
    formValueShowList: {
      type: Array,
      default: function() {
        return []
      }
    },
    widget: {
      type: Object,
      default: function() {
        return {}
      }
    },
    tag: {
      type: Object,
      default: function() {
        return null
      }
    }
  }
}
</script>

<style lang="scss">
.x-color-tag {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  .select-read-tag {
    height: 1.714rem;
    display: flex;
    align-items: center;
    padding: 0 0.786rem;
    border-radius: 1.714rem;
    max-width: 100%;
    box-sizing: border-box;
    margin-right: 4px;
    margin-bottom: 4px;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      line-height: 1;
      display: inline-block;
    }
  }
}
</style>
